import { render, staticRenderFns } from "./TAddReport.vue?vue&type=template&id=23332b2e&scoped=true&"
import script from "./TAddReport.vue?vue&type=script&lang=js&"
export * from "./TAddReport.vue?vue&type=script&lang=js&"
import style0 from "./TAddReport.vue?vue&type=style&index=0&id=23332b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23332b2e",
  null
  
)

export default component.exports